"use strict";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  CarrabbasCmsTheme: () => CarrabbasCmsTheme,
  CarrabbasSharedTheme: () => CarrabbasSharedTheme,
  CarrabbasTheme: () => CarrabbasTheme,
  CarrabbasUITheme: () => CarrabbasUITheme,
  OutbackCmsTheme: () => OutbackCmsTheme,
  OutbackSharedTheme: () => OutbackSharedTheme,
  OutbackTheme: () => OutbackTheme,
  OutbackUITheme: () => OutbackUITheme
});
module.exports = __toCommonJS(src_exports);

// src/bbi/outback/outbackSharedTheme.ts
var import_styled_components = require("styled-components");
var OutbackSharedTheme = {
  colors: {
    primary: {
      light: "#cd2b2b",
      lightContrast: "#d63d3d",
      medium: "#891a1c",
      dark: "#60181b"
    },
    secondary: {
      light: "#f6f2e8",
      medium: "#e6ddcf",
      dark: "#d3c6b3"
    },
    terciary: {
      light: "#f6f6f6",
      medium: "#757575",
      dark: "#2c2c2b"
    },
    complementary: {
      success: "#2d8633",
      error: "#b00020",
      errorText: "#fff",
      warning: "#ffB61f",
      information: "#1c9Bdb",
      hyperlink: "#3078cd"
    },
    neutral: {
      black: "#000000",
      white: "#ffffff",
      gray: "#eaeaea",
      disabled: "#ABABAA"
    }
  },
  typography: {
    headline: {
      h1: import_styled_components.css`
				font-family: 'Veneer';
				font-size: 48px;
				line-height: 52px;
			`,
      h2: import_styled_components.css`
				font-family: 'Veneer';
				font-size: 40px;
				line-height: 44px;
			`,
      h3: import_styled_components.css`
				font-family: 'Veneer';
				font-size: 32px;
				line-height: 36px;
			`,
      h4: import_styled_components.css`
				font-family: 'Veneer';
				font-size: 24px;
				line-height: 28px;
			`,
      h5: import_styled_components.css`
				font-family: 'Veneer';
				font-size: 20px;
				line-height: 24px;
			`,
      h6: import_styled_components.css`
				font-family: 'Veneer';
				font-size: 16px;
				line-height: 20px;
			`
    },
    subtitle: {
      subtitle: import_styled_components.css`
				font-weight: 600;
				font-size: 16px;
				line-height: 20px;
			`
    },
    body: {
      bodySmall: import_styled_components.css`
				font-size: 14px;
				line-height: 20px;
			`,
      body: import_styled_components.css`
				font-size: 16px;
				line-height: 20px;
			`,
      bodyLarge: import_styled_components.css`
				font-size: 18px;
				line-height: 28px;
			`,
      bodySmallBold: import_styled_components.css`
				font-size: 14px;
				line-height: 20px;
				font-weight: 700;
			`
    },
    inputs: {
      buttonSmall: import_styled_components.css`
				font-family: Roboto;
				font-weight: 700;
				font-size: 14px;
				line-height: 18px;
			`,
      button: import_styled_components.css`
				font-family: Roboto;
				font-weight: 700;
				font-size: 16px;
				line-height: 18px;
			`,
      buttonLarge: import_styled_components.css`
				font-family: Roboto;
				font-weight: 700;
				font-size: 18px;
				line-height: 24px;
			`,
      italicButton: import_styled_components.css`
				font-family: Roboto;
				font-style: italic;
				font-weight: 500;
				font-size: 14px;
				line-height: 18px;
			`,
      textInputs: import_styled_components.css`
				font-size: 16px;
				line-height: 20px;
			`,
      textInputsSmall: import_styled_components.css`
				font-size: 14px;
				line-height: 18px;
			`
    },
    caption: {
      caption: import_styled_components.css`
				font-size: 12px;
				line-height: 16px;
			`,
      captionMedium: import_styled_components.css`
				font-weight: 500;
				font-size: 12px;
				line-height: 16px;
			`,
      captionLarge: import_styled_components.css`
				font-weight: 400;
				font-size: 16px;
				line-height: 20px;
			`,
      captionBold: import_styled_components.css`
				font-weight: 700;
				font-size: 12px;
				line-height: 16px;
			`
    },
    overline: {
      overline: import_styled_components.css`
				font-size: 10px;
				line-height: 14px;
				letter-spacing: 1.5px;
				text-transform: uppercase;
			`
    }
  },
  background: {
    dark: {
      image: "/image/outback/dark-background-image.png",
      color: "#262524"
    },
    light: {
      image: "",
      color: ""
    }
  }
};

// src/bbi/outback/outbackCmsTheme.ts
var OutbackCmsTheme = {
  articlePage: {
    fontFamily: "",
    lineHeight: "",
    a: {
      color: "#891a1c"
    }
  }
};

// src/bbi/outback/outbackComponentsStyle/outbackAccordion.ts
var outbackAccordionStyle = {
  variant: {
    primary: {
      background: "url(/image/outback/dark-background-image.png) #262524",
      fontColor: "#ffffff"
    },
    secondary: {
      background: "none",
      fontColor: "#000000"
    }
  },
  title: {
    fontFamily: "IntroRust, sans-serif",
    fontColor: "#ffff",
    fontWeight: "400",
    fontSizes: {
      small: "1.5rem",
      medium: "2.2rem"
    }
  },
  subtitle: {
    fontFamily: "TradeGothicLTPro, sans-serif",
    fontColor: "#ffff",
    fontWeight: "400",
    fontSizes: {
      small: "0.9rem",
      medium: "1.3rem"
    }
  },
  accordionItem: {
    title: {
      fontFamily: "IntroRust, sans-serif",
      fontColor: "#ffff",
      fontWeight: "400",
      fontSizes: {
        small: "1.2rem",
        medium: "1.5rem"
      }
    },
    text: {
      fontFamily: "TradeGothic, sans-serif",
      fontColor: "#ffff",
      fontWeight: "400",
      fontSizes: {
        medium: "1.3rem"
      }
    }
  }
};

// src/bbi/outback/outbackComponentsStyle/outbackCardSecondary.ts
var outbackCardSecondaryStyles = {
  title: {
    fontColor: "#333",
    fontFamily: "IntroRust, sans-serif",
    fontSizes: {
      medium: "1.5rem"
    },
    fontWeight: "500"
  },
  notes: {
    fontColor: "#757575",
    fontFamily: "TradeGothic, sans-serif",
    fontSizes: {
      medium: "1.4rem"
    },
    fontWeight: ""
  },
  text: {
    fontColor: "#333",
    fontFamily: "TradeGothic, sans-serif",
    fontSizes: {
      medium: "1.2rem"
    },
    fontWeight: ""
  },
  button: {
    fontColor: "#333",
    fontFamily: "TradeGothic, sans-serif",
    fontSizes: {
      medium: "1.2rem"
    },
    fontWeight: "bold",
    hoverOpcatity: "none"
  }
};

// src/bbi/outback/outbackComponentsStyle/outbackButtonCms.ts
var outbackButtonCmsStyle = {
  primary: {
    fontFamily: "TradeGothic, sans-serif",
    lineHeight: "1.3rem",
    backgroundColor: "#891a1c",
    hoverColor: "#60181b",
    fontWeight: "bold",
    fontSizes: {
      medium: "1.6rem",
      large: "1.4rem",
      small: "0.95rem"
    },
    borderColor: "transparent",
    color: "#fff",
    padding: "0"
  },
  secondary: {
    fontFamily: "TradeGothic, sans-serif",
    lineHeight: "1rem",
    fontSizes: {
      medium: "1.6rem",
      large: "1.4rem",
      small: "0.95rem"
    },
    hoverColor: "#753336",
    backgroundColor: "transparent",
    fontWeight: "bold",
    borderColor: "#ffff",
    color: "#ffff",
    padding: "0"
  },
  terciary: {
    fontFamily: "TradeGothic, sans-serif",
    lineHeight: "unset",
    fontSizes: {
      medium: "1.2rem",
      large: "1.6rem",
      small: "0.95rem"
    },
    hoverColor: "#753336",
    backgroundColor: "transparent",
    fontWeight: "bold",
    borderColor: "#000",
    color: "#000",
    padding: "0"
  },
  bodyBannerVariant: {
    fontFamily: "TradeGothic, sans-serif",
    lineHeight: "unset",
    fontSizes: {
      medium: "1.2rem",
      large: "1.6rem",
      small: "0.95rem"
    },
    hoverColor: "#753336",
    backgroundColor: "transparent",
    fontWeight: "bold",
    borderColor: "#ffff",
    color: "#ffff",
    padding: "0"
  }
};

// src/bbi/outback/outbackComponentsStyle/outbackCatalog.ts
var outbackCatalogStyle = {
  title: {
    fontColor: "#404041",
    fontFamily: "TradeGothic, sans-serif",
    fontSizes: {
      medium: "2rem"
    },
    fontWeight: "400"
  },
  button: {
    fontColor: "#FFFFFF",
    backgroundColor: "#404041",
    fontFamily: "TradeGothic, sans-serif",
    fontSizes: {
      small: "1.25rem",
      medium: "1.5rem"
    },
    fontWeight: "400"
  },
  backgroundColor: "#ededed"
};

// src/bbi/outback/outbackComponentsStyle/outbackCatalogItemSecondary.ts
var outbackCatalogItemSecondaryStyle = {
  title: {
    font: {
      fontFamily: "TradeGothic, sans-serif",
      fontColor: "#666666",
      fontWeight: "400"
    },
    fontSize: {
      fontSizes: {
        medium: "1rem",
        small: "0.75rem",
        smallest: "0.5rem"
      }
    }
  },
  subtitle: {
    font: {
      fontFamily: "TradeGothic, sans-serif",
      fontColor: "#404041",
      fontWeight: "500"
    },
    fontSize: {
      fontSizes: {
        medium: "3.5rem",
        small: "3rem",
        smallest: "2rem"
      }
    }
  },
  text: {
    font: {
      fontFamily: "TradeGothic, sans-serif",
      fontColor: "#666666",
      fontWeight: "400"
    },
    fontSize: {
      fontSizes: {
        medium: "1rem",
        small: "1rem",
        smallest: "1rem"
      }
    }
  },
  button: {
    font: {
      fontFamily: "TradeGothic, sans-serif",
      fontColor: "#666666",
      fontWeight: "600"
    },
    fontSize: {
      fontSizes: {
        medium: "1.25rem",
        small: "1rem",
        smallest: "1rem"
      }
    }
  }
};

// src/bbi/outback/outbackComponentsStyle/outbackInputCms.ts
var outbackInputCmsStyle = {
  primary: {
    input: {
      fontColor: "#262524",
      fontFamily: "Teko, sans-serif",
      fontWeight: "400",
      fontSizes: {
        medium: "1.21rem",
        large: "1.29rem",
        largest: "1.37rem"
      },
      lineHeights: {
        medium: "4.08rem",
        large: "4.36rem",
        largest: "4.63rem"
      },
      background: "#fff",
      placeholderFontColor: "transparent"
    },
    label: {
      fontColor: "#ffffff",
      fontFamily: "TradeGothic, sans-serif",
      fontWeight: "700",
      fontSizes: {
        medium: "1.12rem"
      },
      lineHeights: {
        medium: "1.2rem"
      },
      initialLabelColor: "#ffff",
      finalLabelColor: "#ffff"
    },
    error: {
      fontColor: "",
      fontFamily: "",
      fontWeight: "",
      fontSizes: {
        small: "0.75rem",
        medium: "0.8rem",
        large: "0.85rem",
        largest: "0.9rem"
      },
      lineHeights: {
        small: "0.9rem",
        medium: "0.95rem",
        large: "1rem",
        largest: "1.07rem"
      }
    },
    borderColor: "#e6ddcf"
  },
  secondary: {
    input: {
      fontColor: "#a87139",
      fontFamily: "Teko, sans-serif",
      fontWeight: "400",
      fontSizes: {
        medium: "1.21rem"
      },
      lineHeights: {
        medium: "1.2"
      },
      background: "",
      placeholderFontColor: "#a87139"
    },
    label: {
      fontColor: "",
      fontFamily: "",
      fontWeight: "",
      fontSizes: {},
      lineHeights: {},
      initialLabelColor: "",
      finalLabelColor: ""
    },
    error: {
      fontColor: "",
      fontFamily: "",
      fontWeight: "",
      fontSizes: {},
      lineHeights: {}
    },
    borderColor: ""
  },
  terciary: {
    input: {
      fontColor: "",
      fontFamily: "",
      fontWeight: "",
      fontSizes: {},
      lineHeights: {},
      background: "",
      placeholderFontColor: "transparent"
    },
    label: {
      fontColor: "inherit",
      fontFamily: "",
      fontWeight: "",
      fontSizes: {},
      lineHeights: {},
      initialLabelColor: "",
      finalLabelColor: ""
    },
    error: {
      fontColor: "inherit",
      fontFamily: "",
      fontWeight: "",
      fontSizes: {},
      lineHeights: {}
    },
    borderColor: "#e8dcc2"
  },
  modal: {
    input: {
      fontColor: "",
      fontFamily: "",
      fontWeight: "",
      fontSizes: {},
      lineHeights: {},
      background: "",
      placeholderFontColor: "transparent"
    },
    label: {
      fontColor: "#333",
      fontFamily: "",
      fontWeight: "",
      fontSizes: {},
      lineHeights: {},
      initialLabelColor: "",
      finalLabelColor: "",
      display: "block"
    },
    error: {
      fontColor: "#333",
      fontFamily: "",
      fontWeight: "",
      fontSizes: {},
      lineHeights: {}
    },
    borderColor: "#818181"
  },
  height: "68px"
};

// src/bbi/outback/outbackComponentsStyle/outbackJumbotron.ts
var outbackJumbotronStyles = {
  title: {
    fontColor: "#232222",
    fontFamily: "TradeGothic, sans-serif",
    fontSizes: {
      medium: "3rem"
    },
    fontWeight: "500"
  },
  text: {
    fontColor: "#232222",
    fontFamily: "TradeGothic, sans-serif",
    fontSizes: {
      medium: "1rem"
    },
    fontWeight: "400"
  },
  singleButton: {
    fontColor: "#404041",
    fontFamily: "TradeGothic, sans-serif",
    fontSizes: {
      small: "1.25rem",
      medium: "1.5rem"
    },
    fontWeight: "600",
    backgroundColor: "#ffffff"
  },
  button: {
    fontColor: "#ffffff",
    fontFamily: "TradeGothic, sans-serif",
    fontSizes: {
      small: "0.875rem",
      medium: "1rem"
    },
    fontWeight: "600",
    backgroundColor: "#404041"
  },
  notes: {
    fontColor: "#232222",
    fontFamily: "TradeGothic, sans-serif",
    fontSizes: {
      medium: "1rem"
    },
    fontWeight: "400"
  }
};

// src/bbi/outback/outbackComponentsStyle/outbackLine.ts
var outbackLine = {
  text: {
    font: {
      fontColor: "#666666",
      fontFamily: "TradeGothic, sans-serif",
      fontWeight: "400"
    },
    fontSize: {
      fontSizes: {
        medium: "1.187rem",
        small: "1.187rem",
        smallest: "1.187rem"
      }
    }
  },
  lineColor: {
    Dotted: "#9e1d21",
    Solid: "#666666"
  }
};

// src/bbi/outback/outbackComponentsStyle/outbackRewardsModal.ts
var outbackRewardsModal = {
  backgroundColor: "#f6f2e8e6",
  closeIconColor: "#716861",
  checkbox: {
    fontColor: "#333",
    fontFamily: "TradeGhotic",
    fontWeight: "500",
    fontSize: "15px",
    fontStyle: "italic",
    border: "none"
  },
  logoColor: "#333",
  button: {
    backgroundColor: "transparent",
    fontColor: "#333",
    borderColor: "#333",
    hoverColor: "#333"
  },
  title: {
    fontColor: "#333",
    fontSizes: {
      small: "1.6rem",
      medium: "1.9rem",
      large: "2.1rem"
    }
  },
  subtitle: {
    fontColor: "#333"
  }
};

// src/bbi/outback/outbackComponentsStyle/outbackNewsletterForm.ts
var outbackNewsletterForm = {
  background: "url(https://edge.sitecorecloud.io/osi-60501bcc/media/Project/BBI/outback/static-pages/texture-slate.png) 0 0 repeat #262524",
  title: {
    fontSizes: {
      medium: "2.25rem"
    },
    fontFamily: "TradeGothic, sans-serif",
    fontWeight: "bold",
    fontColor: "#ffffff"
  },
  agreement: {
    fontFamily: "TradeGothic, sans-serif",
    fontWeight: "bold",
    fontColor: "#ffffff",
    fontSizes: {
      medium: "0.75rem"
    }
  },
  button: {
    fontWeight: "bold",
    fontFamily: "TradeGothic, sans-serif",
    fontColor: "#ffffff",
    fontSizes: {
      smallest: "1.25rem",
      small: "1.45rem",
      medium: "1.6rem",
      large: "1.85rem",
      largest: "1.95rem"
    },
    backgroundColor: "transparent",
    borderColor: "#ffffff"
  },
  form: {
    fontFamily: "TradeGothic, sans-serif",
    fontColor: "#ffffff",
    fontWeight: ""
  },
  response: {
    fontFamily: "TradeGothic, sans-serif",
    fontColor: "#ffffff",
    fontWeight: "600",
    fontSizes: {
      small: "1.75rem",
      medium: "2rem",
      large: "2.25rem"
    }
  }
};

// src/bbi/outback/outbackComponentsStyle/outbackTabNavigationItem.ts
var outbackTabNavigationItem = {
  backgroundColorInactive: "#ededed",
  backgroundColorActive: "#184722",
  separatorColor: "#d3d3d3",
  link: {
    font: {
      fontColor: "#404041",
      fontFamily: "TradeGhotic",
      fontWeight: "600"
    },
    fontSize: {
      fontSizes: {
        medium: "1.5rem",
        small: "0.75rem"
      }
    }
  },
  linkActiveColor: "#ffffff",
  underlineColor: {
    inactive: {
      zeroOpacity: "rgba(64, 64, 65, 0)",
      fullOpacity: "rgba(64, 64, 65, 1)"
    },
    active: {
      zeroOpacity: "rgba(255, 255, 255, 0)",
      fullOpacity: "rgba(255, 255, 255, 1)"
    }
  }
};

// src/bbi/outback/outbackComponentsStyle/outbackQuestionsAndAnswers.ts
var outbackQuestionsAndAnswers = {
  title: {
    fontFamily: "TradeGothic, sans-serif",
    fontWeight: "600",
    fontColor: "#666666",
    fontSizes: {
      medium: "4rem",
      small: "1.5rem"
    }
  },
  text: {
    fontFamily: "TradeGothic, sans-serif",
    fontWeight: "400",
    fontColor: "#666666",
    fontSizes: {
      medium: "2rem",
      small: "1.25rem"
    }
  },
  pagination: {
    fontFamily: "TradeGothic, sans-serif",
    fontWeight: "400",
    fontColor: "#666666",
    fontSizes: {
      medium: "1rem",
      small: "0.75rem"
    }
  },
  arrowColor: "#2c2c2b",
  paginationBorderColor: "#666666"
};

// src/bbi/outback/outbackComponentsStyle/outbackQuestionsAndAnswersItem.ts
var outbackQuestionsAndAnswersItem = {
  name: {
    fontFamily: "TradeGothic, sans-serif",
    fontWeight: "400",
    fontColor: "#666666",
    fontSizes: {
      medium: "1.5rem"
    }
  },
  questionAnswer: {
    fontFamily: "TradeGothic, sans-serif",
    fontWeight: "400",
    fontColor: "#666666",
    fontSizes: {
      medium: "1.125rem"
    }
  }
};

// src/bbi/outback/outbackComponentsStyle/outbackLateralBar.ts
var outbackLateralBar = {
  backgroundColor: "#931a1a",
  font: {
    fontFamily: "TradeGothic, sans-serif",
    fontColor: "#ffffff",
    fontWeight: "600",
    fontSizes: {
      medium: "16px"
    }
  }
};

// src/bbi/outback/outbackComponentsStyle/outbackLegalPages.ts
var outbackLegalPagesStyle = {
  backgroundColor: "#f6f2e8",
  header: {
    title: {
      fontColor: "#891A1C",
      fontFamily: "TradeGothic, sans-serif",
      fontWeight: "700",
      fontSizes: {
        medium: ""
      }
    },
    subtitle: {
      fontColor: "#891A1C",
      fontFamily: "TradeGothic, sans-serif",
      fontWeight: "700",
      fontSizes: {
        medium: ""
      }
    }
  },
  mainContent: {
    subtitles: {
      fontColor: "#891A1C",
      fontFamily: "TradeGothic, sans-serif",
      fontWeight: "700",
      fontSizes: {
        medium: "1.2rem"
      }
    },
    texts: {
      fontColor: "#000",
      fontFamily: "TradeGothic, sans-serif",
      fontWeight: "400",
      fontSizes: {
        medium: ""
      }
    }
  },
  table: {
    backgroundColor: "#262524",
    borderColor: "#ddd"
  }
};

// src/bbi/outback/outbackComponentsStyle/outbackVideoTextButton.ts
var outbackVideoTextButton = {
  title: {
    fontColor: "#232222",
    fontFamily: "TradeGothic, sans-serif",
    fontSizes: {
      medium: "2rem",
      small: "1.5rem"
    },
    fontWeight: "600"
  },
  text: {
    fontColor: "#232222",
    fontFamily: "TradeGothic, sans-serif",
    fontSizes: {
      medium: "1.25rem"
    },
    fontWeight: "400"
  },
  note: {
    fontColor: "#232222",
    fontFamily: "TradeGothic, sans-serif",
    fontSizes: {
      medium: "1.25rem"
    },
    fontWeight: "400"
  },
  button: {
    fontColor: "#ffffff",
    fontFamily: "TradeGothic, sans-serif",
    fontSizes: {
      small: "0.875rem",
      medium: "1.5rem"
    },
    fontWeight: "600",
    backgroundColor: "#404041"
  },
  lineColor: "#232222"
};

// src/bbi/outback/outbackComponentsStyle/outbackHero.ts
var outbackHero = {
  button: {
    fontColor: "#FFFFFF",
    fontWeight: "bold",
    fontFamily: "TradeGothic, sans-serif",
    fontSizes: {
      medium: "1rem"
    },
    backgroundColor: "none",
    hover: {
      opacity: 1,
      backgroundColor: "#FFFFFF",
      font: {
        fontColor: "#000000",
        fontFamily: "TradeGothic, sans-serif",
        fontWeight: "400"
      }
    }
  },
  overTitle: {
    fontColor: "#FFFFFF",
    fontFamily: "TradeGothic, sans-serif",
    fontWeight: "600",
    fontSizes: {
      medium: "1.5rem",
      small: "1.2rem",
      smallest: "1rem"
    },
    letterSpacing: "unset"
  },
  title: {
    fontColor: "#FFFFFF",
    fontFamily: "TradeGothic, sans-serif",
    fontWeight: "bold",
    fontSizes: {
      medium: "4rem",
      small: "3rem",
      smallest: "2rem"
    },
    textTransform: "uppercase",
    lineHeight: {
      medium: "5.4rem",
      small: "5.4rem",
      smallest: "5.4rem"
    }
  },
  text: {
    fontColor: "#FFFFFF",
    fontFamily: "TradeGothic, sans-serif",
    fontWeight: "400",
    fontSizes: {
      medium: "1.5rem",
      small: "1.2rem",
      smallest: "1rem"
    }
  }
};

// src/bbi/outback/outbackComponentsStyle/outbackPod.ts
var outbackPodStyle = {
  large: {
    title: {
      fontFamily: "IntroRust, sans-serif",
      fontSizes: {
        smallest: "1.625rem",
        small: "1.775rem",
        medium: "2rem",
        large: "2.25rem",
        largest: "2.5rem"
      },
      fontColor: { desktop: "#fff", mobile: "#000" },
      fontWeight: "normal"
    },
    borders: "",
    description: {
      fontFamily: "TradeGothic, sans-serif",
      fontSizes: {
        smallest: "0.82rem",
        small: "0.885rem",
        medium: "0.955rem",
        large: "1.095rem",
        largest: "1.163rem"
      },
      fontColor: { desktop: "#fff", mobile: "#000" },
      fontWeight: "normal",
      textTransform: "uppercase"
    },
    button: {
      backgroundColor: { desktop: "#9E1D21", mobile: "#9E1D21" },
      font: {
        fontFamily: "TradeGothic, sans-serif",
        fontSizes: {
          smallest: "1.25rem",
          small: "1.365rem",
          medium: "1.5rem",
          large: "1.75rem",
          largest: "2rem"
        },
        fontColor: { desktop: "#fff", mobile: "#fff" },
        fontWeight: "bold"
      },
      borderColor: { desktop: "none", mobile: "none" },
      hoverColor: { desktop: "#731518", mobile: "#731518" }
    },
    padding: ""
  },
  middle: {
    title: {
      fontFamily: "IntroRust, sans-serif",
      fontSizes: {},
      fontColor: { desktop: "#fff", mobile: "#000" },
      fontWeight: "normal",
      paddingMobile: "0px"
    },
    borders: "",
    description: {
      fontFamily: "TradeGothic, sans-serif",
      fontSizes: {},
      fontColor: { desktop: "#fff", mobile: "#000" },
      fontWeight: "bold",
      textTransform: ""
    },
    button: {
      backgroundColor: { desktop: "transparent", mobile: "transparent" },
      font: {
        fontFamily: "TradeGothic, sans-serif",
        fontSizes: {},
        fontColor: { desktop: "#fff", mobile: "#000" },
        fontWeight: "bold"
      },
      borderColor: { desktop: "none", mobile: "none" },
      hoverColor: { desktop: "#2C2C2B", mobile: "#2C2C2B" }
    },
    padding: "10px 15px"
  },
  small: {
    title: {
      fontFamily: "IntroRust, sans-serif",
      fontSizes: {
        smallest: "1.625rem",
        small: "1.775rem",
        medium: "2rem",
        large: "2.25rem",
        largest: "2.5rem"
      },
      fontColor: { desktop: "#fff", mobile: "#000" },
      fontWeight: "normal",
      paddingMobile: "0px"
    },
    borders: "",
    description: {
      fontFamily: "TradeGothic, sans-serif",
      fontSizes: { medium: "1rem" },
      fontColor: { desktop: "#fff", mobile: "#000" },
      fontWeight: "bold",
      textTransform: ""
    },
    button: {
      backgroundColor: { desktop: "transparent", mobile: "transparent" },
      font: {
        fontFamily: "TradeGothic, sans-serif",
        fontSizes: {
          smallest: "1.25rem",
          small: "1.365rem",
          medium: "1.5rem",
          large: "1.6rem",
          largest: "1.7rem"
        },
        fontColor: { desktop: "#fff", mobile: "#000" },
        fontWeight: "bold"
      },
      borderColor: { desktop: "none", mobile: "none" },
      hoverColor: { desktop: "#2C2C2B", mobile: "#2C2C2B" }
    },
    padding: ""
  }
};

// src/bbi/outback/outbackComponentsStyle/outbackHeader.ts
var outbackHeaderStyle = {
  image: {
    width: "80px",
    height: "30px"
  },
  title: {
    fontSizes: {
      small: "1.2rem",
      medium: "1.4rem"
    }
  },
  subTitle: {
    fontSizes: {
      small: "14px",
      medium: "18px"
    }
  }
};

// src/bbi/outback/outbackUITheme.ts
var OutbackUITheme = {
  accordion: outbackAccordionStyle,
  ButtonCMS: outbackButtonCmsStyle,
  carouselDots: {
    iconPlayAndPause: {
      background: "#d3c6b3",
      color: "#891A1C"
    },
    background: "#f6f2e8"
  },
  footer: {
    letterSpacing: "-1px",
    navbar: {
      marginBottom: "0px",
      color: "#262524",
      secondary: {
        fontFamily: "TradeGothicLTPro-Bold, sans-serif",
        menuItem: {
          fontSizes: {
            smallest: "0.8rem",
            small: "0.85rem",
            medium: "0.9rem",
            large: "0.95rem",
            largest: "1rem"
          }
        }
      },
      terciary: {
        fontFamily: "TradeGothicLTPro, sans-serif",
        menuItem: {
          fontSizes: {
            smallest: "0.7rem",
            small: "0.75rem",
            medium: "0.8rem",
            large: "0.85rem",
            largest: "0.9rem"
          }
        }
      }
    },
    socialMediaPanel: {
      fontFamily: "TradeGothicLTPro, sans-serif",
      fontSizes: {
        medium: "0.7rem",
        large: "0.75rem",
        largest: "0.8rem"
      }
    }
  },
  navBar: {
    primary: {
      fontFamily: "TradeGothic, sans-serif",
      fontWeight: "bold",
      fontColor: "",
      fontSizes: {
        default: "1.8rem"
      },
      color: "#ffffff"
    }
  },
  topMessage: {
    text: {
      fontFamily: "IntroRust, sans-serif",
      fontSizes: {
        default: "15px",
        medium: "18px"
      }
    }
  },
  header: outbackHeaderStyle,
  pod: outbackPodStyle,
  forms: {
    button: {
      fontColor: "#FFFFFF",
      backgroundColor: "transparent",
      fontWeight: "bold",
      fontFamily: "TradeGothicLTPro-Bold, sans-serif",
      fontSizes: { small: "1.25rem", medium: "1.5rem", large: "1.7rem" },
      hoverColor: "transparent",
      border: "1px solid transparent"
    },
    texts: {
      title: {
        fontColor: "#FFFFFF",
        fontSizes: { small: "1.75rem", medium: "2rem", large: "2.25rem" },
        fontFamily: "IntroRust, sans-serif",
        fontWeight: "500"
      },
      description: {
        fontColor: "#FFFFFF",
        fontSizes: { medium: "1.13rem" },
        fontFamily: "TradeGothic, sans-serif",
        fontWeight: "400"
      },
      label: {
        fontColor: "#FFFFFF",
        fontFamily: "TradeGothic, sans-serif",
        fontWeight: "600"
      }
    },
    backgroundColor: "#262524",
    borders: "#e6ddcf"
  },
  hero: outbackHero,
  animatedCard: {
    title: {
      fontColor: "#931C20",
      fontFamily: "TradeGothic, sans-serif",
      fontWeight: "600",
      fontSizes: {
        medium: "2rem",
        large: "2.25rem"
      }
    },
    text: {
      fontColor: "#404041",
      fontFamily: "TradeGothic, sans-serif",
      fontWeight: "400",
      fontSizes: {
        medium: "1rem"
      }
    }
  },
  animatedCardSecondary: {
    title: {
      fontColor: "#404041",
      fontFamily: "TradeGothic, sans-serif",
      fontWeight: "400",
      fontSizes: {
        medium: "1.5rem"
      }
    },
    text: {
      fontColor: "#666666",
      fontFamily: "TradeGothic, sans-serif",
      fontWeight: "400",
      fontSizes: {
        medium: "1rem"
      }
    },
    button: {
      fontColor: "#ffffff",
      fontFamily: "TradeGothic, sans-serif",
      fontWeight: "600",
      fontSizes: {
        medium: "0.875rem"
      },
      backgroundColor: "#404041"
    }
  },
  catalogItem: {
    title: {
      font: {
        fontFamily: "TradeGothic, sans-serif",
        fontColor: "#931c20",
        fontWeight: "600"
      },
      fontSize: {
        fontSizes: {
          medium: "2.25rem",
          small: "2rem",
          smallest: "1.75rem"
        }
      }
    },
    subtitle: {
      font: {
        fontFamily: "TradeGothic, sans-serif",
        fontColor: "#404041",
        fontWeight: "600"
      },
      fontSize: {
        fontSizes: {
          medium: "1.25rem",
          small: "1rem",
          smallest: "0.75rem"
        }
      }
    },
    text: {
      font: {
        fontFamily: "TradeGothic, sans-serif",
        fontColor: "#404041",
        fontWeight: "400"
      },
      fontSize: {
        fontSizes: {
          medium: "1rem",
          small: "0.8rem",
          smallest: "0.7rem"
        }
      }
    },
    note: {
      font: {
        fontFamily: "TradeGothic, sans-serif",
        fontColor: "#931c20",
        fontWeight: "400"
      },
      fontSize: {
        fontSizes: {
          medium: "1rem",
          small: "0.8rem",
          smallest: "0.7rem"
        }
      }
    }
  },
  catalogItemSecondary: outbackCatalogItemSecondaryStyle,
  textButtonBanner: {
    title: {
      fontColor: "#ffffff",
      fontFamily: "TradeGothic, sans-serif",
      fontSizes: {
        small: "1rem",
        medium: "1.25rem",
        large: "1.5rem"
      },
      fontWeight: "600"
    },
    button: {
      fontColor: "#404041",
      fontFamily: "TradeGothic, sans-serif",
      fontSizes: {
        small: "1rem",
        medium: "1.25rem",
        large: "1.5rem"
      },
      fontWeight: "600",
      backgroundColor: "#ffffff"
    }
  },
  inputCms: outbackInputCmsStyle,
  rewardsModal: outbackRewardsModal,
  cardSecondary: outbackCardSecondaryStyles,
  grid: {
    maxWidth: "none",
    margin: "auto"
  },
  jumbotron: outbackJumbotronStyles,
  catalog: outbackCatalogStyle,
  line: outbackLine,
  newsletterForm: outbackNewsletterForm,
  tabNavigationItem: outbackTabNavigationItem,
  questionsAndAnswers: outbackQuestionsAndAnswers,
  questionsAndAnswersItem: outbackQuestionsAndAnswersItem,
  lateralBar: outbackLateralBar,
  legalPages: outbackLegalPagesStyle,
  videoTextButton: outbackVideoTextButton
};

// src/bbi/outback/outbackTheme.ts
var OutbackTheme = __spreadProps(__spreadValues({}, OutbackSharedTheme), {
  components: __spreadValues({}, OutbackUITheme),
  cmsComponents: __spreadValues({}, OutbackCmsTheme)
});

// src/bbi/carrabbas/carrabbasSharedTheme.ts
var import_styled_components2 = require("styled-components");
var CarrabbasSharedTheme = {
  colors: {
    primary: {
      light: "#437F78",
      lightContrast: "#184722",
      medium: "#9E1D21",
      dark: "#9E1D21"
    },
    secondary: {
      light: "#EDEDED",
      medium: "#e6ddcf",
      dark: "#d3c6b3"
    },
    terciary: {
      light: "#f6f6f6",
      medium: "#404041",
      dark: "#F5F3EB"
    },
    complementary: {
      success: "#2d8633",
      error: "#b00020",
      errorText: "#b00020",
      warning: "#ffB61f",
      information: "#1c9Bdb",
      hyperlink: "#3078cd"
    },
    neutral: {
      black: "#404041",
      white: "#ffffff",
      gray: "#eaeaea",
      disabled: "#ABABAA"
    }
  },
  typography: {
    headline: {
      h1: import_styled_components2.css`
				font-family: 'Veneer';
				font-size: 48px;
				line-height: 52px;
			`,
      h2: import_styled_components2.css`
				font-family: 'Veneer';
				font-size: 40px;
				line-height: 44px;
			`,
      h3: import_styled_components2.css`
				font-family: 'Veneer';
				font-size: 32px;
				line-height: 36px;
			`,
      h4: import_styled_components2.css`
				font-family: 'Veneer';
				font-size: 24px;
				line-height: 28px;
			`,
      h5: import_styled_components2.css`
				font-family: 'Veneer';
				font-size: 20px;
				line-height: 24px;
			`,
      h6: import_styled_components2.css`
				font-family: 'Veneer';
				font-size: 16px;
				line-height: 20px;
			`
    },
    subtitle: {
      subtitle: import_styled_components2.css`
				font-weight: 600;
				font-size: 16px;
				line-height: 20px;
			`
    },
    body: {
      bodySmall: import_styled_components2.css`
				font-size: 14px;
				line-height: 20px;
			`,
      body: import_styled_components2.css`
				font-size: 16px;
				line-height: 20px;
			`,
      bodyLarge: import_styled_components2.css`
				font-size: 18px;
				line-height: 28px;
			`,
      bodySmallBold: import_styled_components2.css`
				font-size: 14px;
				line-height: 20px;
				font-weight: 700;
			`
    },
    inputs: {
      buttonSmall: import_styled_components2.css`
				font-family: Roboto;
				font-weight: 700;
				font-size: 14px;
				line-height: 18px;
			`,
      button: import_styled_components2.css`
				font-family: Roboto;
				font-weight: 700;
				font-size: 16px;
				line-height: 18px;
			`,
      buttonLarge: import_styled_components2.css`
				font-family: Roboto;
				font-weight: 700;
				font-size: 18px;
				line-height: 24px;
			`,
      italicButton: import_styled_components2.css`
				font-family: Roboto;
				font-style: italic;
				font-weight: 500;
				font-size: 14px;
				line-height: 18px;
			`,
      textInputs: import_styled_components2.css`
				font-size: 16px;
				line-height: 20px;
			`,
      textInputsSmall: import_styled_components2.css`
				font-size: 14px;
				line-height: 18px;
			`
    },
    caption: {
      caption: import_styled_components2.css`
				font-size: 12px;
				line-height: 16px;
			`,
      captionMedium: import_styled_components2.css`
				font-weight: 500;
				font-size: 12px;
				line-height: 16px;
			`,
      captionLarge: import_styled_components2.css`
				font-weight: 400;
				font-size: 16px;
				line-height: 20px;
			`,
      captionBold: import_styled_components2.css`
				font-weight: 700;
				font-size: 12px;
				line-height: 16px;
			`
    },
    overline: {
      overline: import_styled_components2.css`
				font-size: 10px;
				line-height: 14px;
				letter-spacing: 1.5px;
				text-transform: uppercase;
			`
    }
  },
  background: {
    dark: {
      image: "/image/outback/dark-background-image.png",
      color: "#262524"
    },
    light: {
      image: "",
      color: ""
    }
  }
};

// src/bbi/carrabbas/carrabbasCmsTheme.ts
var CarrabbasCmsTheme = {
  articlePage: {
    fontFamily: "",
    lineHeight: "",
    a: {
      color: "blue"
    }
  }
};

// src/bbi/carrabbas/carrabbasComponentsStyle/carrabbasAcccordion.ts
var carrabbasAccordion = {
  variant: {
    primary: {
      background: "#ffffff",
      fontColor: "#666666"
    },
    secondary: {
      background: "#DEDACE",
      fontColor: "#666666"
    }
  },
  title: {
    fontFamily: "Gibson-SemiBold",
    fontColor: "#ffff",
    fontWeight: "400",
    fontSizes: {
      small: "1.5rem",
      medium: "2rem"
    }
  },
  subtitle: {
    fontFamily: "Gibson-Regular",
    fontColor: "#ffff",
    fontWeight: "400",
    fontSizes: {
      small: "0.9",
      medium: "1.2rem"
    }
  },
  accordionItem: {
    title: {
      fontFamily: "Gibson-SemiBold",
      fontColor: "#666666",
      fontWeight: "600",
      fontSizes: {
        small: "2rem",
        medium: "2rem"
      }
    },
    text: {
      fontFamily: "Gibson-Regular",
      fontColor: "#666666",
      fontWeight: "400",
      fontSizes: {
        small: "1.25rem",
        medium: "1.25rem"
      }
    }
  }
};

// src/bbi/carrabbas/carrabbasComponentsStyle/carrabbasButtonCms.ts
var carrabbasButtonCmsStyle = {
  primary: {
    fontFamily: "Gibson-SemiBold",
    lineHeight: "1.75rem",
    backgroundColor: "#9e1d21",
    hoverColor: "#60181b",
    fontWeight: "600",
    fontSizes: {
      medium: "1.5rem",
      large: "1rem",
      small: "1.6rem"
    },
    borderColor: "transparent",
    color: "#fff",
    padding: "0"
  },
  secondary: {
    fontFamily: "Gibson-SemiBold",
    lineHeight: "1rem",
    fontSizes: {
      medium: "1.6rem",
      large: "1rem",
      small: "1.6rem"
    },
    hoverColor: "#753336",
    backgroundColor: "#fff",
    fontWeight: "600",
    borderColor: "#000",
    color: "#000",
    padding: "0 "
  },
  terciary: {
    fontFamily: "Gibson-SemiBold",
    fontSizes: {
      medium: "1.5rem",
      small: "0.875rem"
    },
    hoverColor: "#753336",
    backgroundColor: "#404041",
    fontWeight: "600",
    lineHeight: "1rem",
    borderColor: "#fff",
    color: "#fff",
    padding: "16px"
  },
  bodyBannerVariant: {
    fontFamily: "Gibson-SemiBold",
    fontSizes: {
      medium: "1.5rem",
      small: "0.875rem"
    },
    hoverColor: "#753336",
    backgroundColor: "#404041",
    fontWeight: "600",
    lineHeight: "1rem",
    borderColor: "#fff",
    color: "#fff",
    padding: "16px"
  }
};

// src/bbi/carrabbas/carrabbasComponentsStyle/carrabbasCardSecondaryStyle.ts
var carrabbasCardSecondaryStyles = {
  title: {
    fontColor: "#404041",
    fontFamily: "Gibson-SemiBold",
    fontSizes: {
      medium: "1.5rem"
    },
    fontWeight: "500"
  },
  notes: {
    fontColor: "#404041",
    fontFamily: "Gibson-Regular",
    fontSizes: {
      medium: "1.4rem"
    },
    fontWeight: ""
  },
  text: {
    fontColor: "#404041",
    fontFamily: "Gibson-Regular",
    fontSizes: {
      medium: "1.2rem"
    },
    fontWeight: ""
  },
  button: {
    fontColor: "#404041",
    fontFamily: "Gibson-SemiBold",
    fontSizes: {
      medium: "1.2rem"
    },
    fontWeight: "bold",
    hoverOpcatity: "0.6"
  }
};

// src/bbi/carrabbas/carrabbasComponentsStyle/carrabbasCatalog.ts
var carrabbasCatalogStyle = {
  title: {
    fontColor: "#404041",
    fontFamily: "Gibson-Regular",
    fontSizes: {
      medium: "2rem"
    },
    fontWeight: "400"
  },
  button: {
    fontColor: "#FFFFFF",
    backgroundColor: "#404041",
    fontFamily: "Gibson-SemiBold",
    fontSizes: {
      small: "1.25rem",
      medium: "1.5rem"
    },
    fontWeight: "400"
  },
  backgroundColor: "#ededed"
};

// src/bbi/carrabbas/carrabbasComponentsStyle/carrabbasCatalogItemSecondary.ts
var carrabbasCatalogItemSecondaryStyle = {
  title: {
    font: {
      fontFamily: "Gibson-Regular",
      fontColor: "#666666",
      fontWeight: "400"
    },
    fontSize: {
      fontSizes: {
        medium: "1rem",
        small: "0.75rem",
        smallest: "0.5rem"
      }
    }
  },
  subtitle: {
    font: {
      fontFamily: "Queens-W",
      fontColor: "#404041",
      fontWeight: "500"
    },
    fontSize: {
      fontSizes: {
        medium: "3.5rem",
        small: "3rem",
        smallest: "2rem"
      }
    }
  },
  text: {
    font: {
      fontFamily: "Gibson-Regular",
      fontColor: "#666666",
      fontWeight: "400"
    },
    fontSize: {
      fontSizes: {
        medium: "1rem",
        small: "1rem",
        smallest: "1rem"
      }
    }
  },
  button: {
    font: {
      fontFamily: "Gibson-Regular",
      fontColor: "#666666",
      fontWeight: "600"
    },
    fontSize: {
      fontSizes: {
        medium: "1.25rem",
        small: "1rem",
        smallest: "1rem"
      }
    }
  }
};

// src/bbi/carrabbas/carrabbasComponentsStyle/carrabbasInputCms.ts
var carrabbasInputCmsStyle = {
  primary: {
    input: {
      fontColor: "#404041",
      fontFamily: "Gibson-SemiBold",
      fontWeight: "600",
      fontSizes: {
        medium: "1rem",
        large: "1rem",
        largest: "1rem"
      },
      lineHeights: {
        medium: "4.08rem",
        large: "4.36rem",
        largest: "4.63rem"
      },
      background: "#fff",
      placeholderFontColor: "#6d6d6d"
    },
    label: {
      fontColor: "transparent",
      fontFamily: "Gibson-SemiBold",
      fontWeight: "700",
      fontSizes: {
        medium: "0.875rem"
      },
      lineHeights: {
        medium: "1.2rem"
      },
      initialLabelColor: "transparent",
      finalLabelColor: "#232222"
    },
    error: {
      fontColor: "",
      fontFamily: "",
      fontWeight: "",
      fontSizes: {
        small: "0.75rem",
        medium: "0.8rem",
        large: "0.85rem",
        largest: "0.9rem"
      },
      lineHeights: {
        small: "0.9rem",
        medium: "0.95rem",
        large: "1rem",
        largest: "1.07rem"
      }
    },
    borderColor: "#404041"
  },
  secondary: {
    input: {
      fontColor: "#a87139",
      fontFamily: "Gibson-Regular",
      fontWeight: "400",
      fontSizes: {
        medium: "1.21rem"
      },
      lineHeights: {
        medium: "1.2"
      },
      background: "",
      placeholderFontColor: "#404041"
    },
    label: {
      fontColor: "",
      fontFamily: "",
      fontWeight: "",
      fontSizes: {},
      lineHeights: {},
      initialLabelColor: "",
      finalLabelColor: ""
    },
    error: {
      fontColor: "",
      fontFamily: "",
      fontWeight: "",
      fontSizes: {},
      lineHeights: {}
    },
    borderColor: ""
  },
  terciary: {
    input: {
      fontColor: "",
      fontFamily: "",
      fontWeight: "",
      fontSizes: {},
      lineHeights: {},
      background: "",
      placeholderFontColor: ""
    },
    label: {
      fontColor: "inherit",
      fontFamily: "",
      fontWeight: "",
      fontSizes: {},
      lineHeights: {},
      initialLabelColor: "",
      finalLabelColor: ""
    },
    error: {
      fontColor: "inherit",
      fontFamily: "",
      fontWeight: "",
      fontSizes: {},
      lineHeights: {}
    },
    borderColor: "#e8dcc2"
  },
  modal: {
    input: {
      fontColor: "",
      fontFamily: "",
      fontWeight: "",
      fontSizes: {},
      lineHeights: {},
      background: "",
      placeholderFontColor: "#666666"
    },
    label: {
      fontColor: "transparent",
      fontFamily: "",
      fontWeight: "",
      fontSizes: {},
      lineHeights: {},
      initialLabelColor: "",
      finalLabelColor: "",
      display: "none"
    },
    error: {
      fontColor: "#333",
      fontFamily: "",
      fontWeight: "",
      fontSizes: {},
      lineHeights: {}
    },
    borderColor: "#666666"
  },
  height: "68px"
};

// src/bbi/carrabbas/carrabbasComponentsStyle/carrabbasJumbotron.ts
var carrabbasJumbotronStyles = {
  title: {
    fontColor: "#232222",
    fontFamily: "Gibson-Regular",
    fontSizes: {
      medium: "2rem"
    },
    fontWeight: "500"
  },
  text: {
    fontColor: "#232222",
    fontFamily: "Gibson-Regular",
    fontSizes: {
      medium: "1.25rem"
    },
    fontWeight: "400"
  },
  singleButton: {
    fontColor: "#404041",
    fontFamily: "Gibson-SemiBold",
    fontSizes: {
      small: "1.25rem",
      medium: "1.5rem"
    },
    fontWeight: "600",
    backgroundColor: "#ffffff"
  },
  button: {
    fontColor: "#ffffff",
    fontFamily: "Gibson-SemiBold",
    fontSizes: {
      small: "0.875rem",
      medium: "1rem",
      large: "1.3rem"
    },
    fontWeight: "600",
    backgroundColor: "#404041"
  },
  notes: {
    fontColor: "#232222",
    fontFamily: "Gibson-Regular",
    fontSizes: {
      medium: "1rem"
    },
    fontWeight: "400"
  }
};

// src/bbi/carrabbas/carrabbasComponentsStyle/carrabbasLine.ts
var carrabbasLine = {
  text: {
    font: {
      fontColor: "#666666",
      fontFamily: "Gibson-Regular",
      fontWeight: "400"
    },
    fontSize: {
      fontSizes: {
        medium: "1.187rem",
        small: "1.187rem",
        smallest: "1.187rem"
      }
    }
  },
  lineColor: {
    Dotted: "#9e1d21",
    Solid: "#666666"
  }
};

// src/bbi/carrabbas/carrabbasComponentsStyle/carrabbasRewardsModal.ts
var carrabbasRewardsModal = {
  backgroundColor: "#ffffffe6",
  closeIconColor: "#9E1D21",
  checkbox: {
    fontColor: "#404041",
    fontFamily: "Gibson-Regular",
    fontWeight: "500",
    fontSize: "1rem",
    fontStyle: "italic",
    border: "2px solid #6666"
  },
  logoColor: "purple",
  button: {
    backgroundColor: "#404041",
    fontColor: "#ffff",
    borderColor: "#404041",
    hoverColor: "#6666"
  },
  title: {
    fontColor: "#404041",
    fontSizes: {
      small: "1.5rem",
      medium: "1.5rem",
      large: "2.1rem"
    }
  },
  subtitle: {
    fontColor: "#404041"
  }
};

// src/bbi/carrabbas/carrabbasComponentsStyle/carrabbasNewsletterForm.ts
var carrabbasNewsletterForm = {
  background: "#F5F3EB",
  title: {
    fontSizes: {
      medium: "2.25rem"
    },
    fontFamily: "Gibson-Regular",
    fontWeight: "600",
    fontColor: "#232222"
  },
  agreement: {
    fontFamily: "Gibson-Regular",
    fontWeight: "400",
    fontColor: "#232222",
    fontSizes: {
      medium: "1rem"
    }
  },
  button: {
    fontWeight: "bold",
    fontFamily: "Gibson-SemiBold",
    fontColor: "#404041",
    fontSizes: {
      smallest: "1.25rem",
      small: "1.45rem",
      medium: "1.6rem",
      large: "1.85rem",
      largest: "1.95rem"
    },
    backgroundColor: "#ffffff",
    borderColor: "transparent"
  },
  form: {
    fontFamily: "Gibson-Regular",
    fontColor: "#404041",
    fontWeight: ""
  },
  response: {
    fontFamily: "Gibson-SemiBold",
    fontColor: "#232222",
    fontWeight: "600",
    fontSizes: {
      small: "1.75rem",
      medium: "2rem",
      large: "2.25rem"
    }
  }
};

// src/bbi/carrabbas/carrabbasComponentsStyle/carrabbasTabNavigationItem.ts
var carrabbasTabNavigationItem = {
  backgroundColorInactive: "#ededed",
  backgroundColorActive: "#184722",
  separatorColor: "#d3d3d3",
  link: {
    font: {
      fontColor: "#404041",
      fontFamily: "Gibson-SemiBold",
      fontWeight: "600"
    },
    fontSize: {
      fontSizes: {
        medium: "1.5rem",
        small: "0.75rem"
      }
    }
  },
  linkActiveColor: "#ffffff",
  underlineColor: {
    inactive: {
      zeroOpacity: "rgba(64, 64, 65, 0)",
      fullOpacity: "rgba(64, 64, 65, 1)"
    },
    active: {
      zeroOpacity: "rgba(255, 255, 255, 0)",
      fullOpacity: "rgba(255, 255, 255, 1)"
    }
  }
};

// src/bbi/carrabbas/carrabbasComponentsStyle/carrabbasQuestionsAndAnswersItem.ts
var carrabbasQuestionsAndAnswersItem = {
  name: {
    fontFamily: "Gibson-Regular",
    fontWeight: "400",
    fontColor: "#666666",
    fontSizes: {
      medium: "1.5rem"
    }
  },
  questionAnswer: {
    fontFamily: "Gibson-Regular",
    fontWeight: "400",
    fontColor: "#666666",
    fontSizes: {
      medium: "1.125rem"
    }
  }
};

// src/bbi/carrabbas/carrabbasComponentsStyle/carrabbasQuestionsAndAnswers.ts
var carrabbasQuestionsAndAnswers = {
  title: {
    fontFamily: "Gibson-SemiBold",
    fontWeight: "600",
    fontColor: "#666666",
    fontSizes: {
      medium: "4rem",
      small: "1.5rem"
    }
  },
  text: {
    fontFamily: "Gibson-Regular",
    fontWeight: "400",
    fontColor: "#666666",
    fontSizes: {
      medium: "2rem",
      small: "1.25rem"
    }
  },
  pagination: {
    fontFamily: "Gibson-Regular",
    fontWeight: "400",
    fontColor: "#666666",
    fontSizes: {
      medium: "1rem",
      small: "0.75rem"
    }
  },
  arrowColor: "#2c2c2b",
  paginationBorderColor: "#666666"
};

// src/bbi/carrabbas/carrabbasComponentsStyle/carrabbasLateralBar.ts
var carrabbasLateralBar = {
  backgroundColor: "#404041",
  font: {
    fontFamily: "Gibson-SemiBold",
    fontColor: "#ffffff",
    fontWeight: "600",
    fontSizes: {
      medium: "16px"
    }
  }
};

// src/bbi/carrabbas/carrabbasComponentsStyle/carrabbasLegalPages.ts
var carrabbasLegalPagesStyle = {
  backgroundColor: "#ffffff",
  header: {
    title: {
      fontColor: "#666666",
      fontFamily: "Gibson-SemiBold",
      fontWeight: "700",
      fontSizes: {
        medium: ""
      }
    },
    subtitle: {
      fontColor: "#666666",
      fontFamily: "Gibson-SemiBold",
      fontWeight: "700",
      fontSizes: {
        medium: ""
      }
    }
  },
  mainContent: {
    subtitles: {
      fontColor: "#666666",
      fontFamily: "Gibson-Regular",
      fontWeight: "700",
      fontSizes: {
        medium: ""
      }
    },
    texts: {
      fontColor: "#666666",
      fontFamily: "Gibson-Regular",
      fontWeight: "400",
      fontSizes: {
        medium: ""
      }
    }
  },
  table: {
    backgroundColor: "#232222",
    borderColor: "#EAEAEA"
  }
};

// src/bbi/carrabbas/carrabbasComponentsStyle/carrabbasVideoTextButton.ts
var carrabbasVideoTextButton = {
  title: {
    fontColor: "#666666",
    fontFamily: "Gibson-SemiBold",
    fontSizes: {
      medium: "2rem",
      small: "1.5rem"
    },
    fontWeight: "600"
  },
  text: {
    fontColor: "#666666",
    fontFamily: "Gibson-Regular",
    fontSizes: {
      medium: "1.25rem"
    },
    fontWeight: "400"
  },
  note: {
    fontColor: "#666666",
    fontFamily: "Gibson-Regular",
    fontSizes: {
      medium: "1.25rem"
    },
    fontWeight: "400"
  },
  button: {
    fontColor: "#ffffff",
    fontFamily: "Gibson-SemiBold",
    fontSizes: {
      small: "0.875rem",
      medium: "1.5rem"
    },
    fontWeight: "600",
    backgroundColor: "#404041"
  },
  lineColor: "#666666"
};

// src/bbi/carrabbas/carrabbasComponentsStyle/carrabbasHero.ts
var carrabbasHero = {
  button: {
    fontColor: "#404041",
    fontWeight: "600",
    fontFamily: "Gibson-SemiBold",
    fontSizes: {
      medium: "1.5rem"
    },
    backgroundColor: "#ffffff",
    hover: {
      opacity: 0.8,
      backgroundColor: "#FFFFFF",
      font: {
        fontColor: "#000000",
        fontFamily: "TradeGothic, sans-serif",
        fontWeight: "400"
      }
    }
  },
  overTitle: {
    fontColor: "#FFFFFF",
    fontFamily: "Gibson-SemiBold",
    fontWeight: "600",
    fontSizes: {
      medium: "1.5rem",
      small: "1.2rem",
      smallest: "1rem"
    },
    letterSpacing: "1px"
  },
  title: {
    fontColor: "#FFFFFF",
    fontFamily: "Queens-W",
    fontWeight: "500",
    fontSizes: {
      medium: "4.25rem",
      small: "3rem",
      smallest: "3rem"
    },
    textTransform: "none",
    lineHeight: {
      medium: "5.4rem",
      small: "3.25rem",
      smallest: "3.25rem"
    }
  },
  text: {
    fontColor: "#FFFFFF",
    fontFamily: "Gibson-Regular",
    fontWeight: "400",
    fontSizes: {
      medium: "1.5rem",
      small: "1.2rem",
      smallest: "1rem"
    }
  }
};

// src/bbi/carrabbas/carrabbasComponentsStyle/carrabbasPod.ts
var carrabbasPodStyle = {
  large: {
    title: {
      fontFamily: "Gibson-SemiBold",
      fontSizes: {
        smallest: "1.75rem",
        small: "1.75rem",
        medium: "1.75rem",
        large: "2rem",
        largest: "2rem"
      },
      fontColor: { desktop: "#fff", mobile: "#000" },
      fontWeight: "bold"
    },
    borders: "",
    description: {
      fontFamily: "Gibson-Regular",
      fontSizes: {
        small: "1rem",
        medium: "0.875rem",
        large: "0.875rem"
      },
      fontColor: { desktop: "#fff", mobile: "#404041" },
      fontWeight: "normal",
      textTransform: "none"
    },
    button: {
      backgroundColor: { desktop: "#9E1D21", mobile: "#9E1D21" },
      font: {
        fontFamily: "Gibson-SemiBold",
        fontSizes: {
          smallest: "1.25rem",
          small: "1.25rem",
          medium: "1.25rem",
          large: "1.5rem",
          largest: "1.5rem"
        },
        fontColor: { desktop: "#fff", mobile: "#fff" },
        fontWeight: "bold"
      },
      borderColor: { desktop: "none", mobile: "none" },
      hoverColor: { desktop: "#731518", mobile: "#731518" }
    },
    padding: ""
  },
  middle: {
    title: {
      fontFamily: "Gibson-Regular",
      fontSizes: {},
      fontColor: { desktop: "#fff", mobile: "#000" },
      fontWeight: "bold",
      paddingMobile: "16px"
    },
    borders: "2px solid #000",
    description: {
      fontFamily: "Gibson-Regular",
      fontSizes: {},
      fontColor: { desktop: "#fff", mobile: "#404041" },
      fontWeight: "normal",
      textTransform: ""
    },
    button: {
      backgroundColor: { desktop: "#fff", mobile: "#9E1D21" },
      font: {
        fontFamily: "Gibson-Regular",
        fontSizes: {},
        fontColor: { desktop: "#000", mobile: "#fff" },
        fontWeight: "bold"
      },
      borderColor: { desktop: "#fff", mobile: "#9E1D21" },
      hoverColor: { desktop: "#EDEDED", mobile: "#731518" }
    },
    padding: "10px 24px;"
  },
  small: {
    title: {
      fontFamily: "Gibson-Regular",
      fontSizes: {
        smallest: "1.75rem",
        small: "1.75rem",
        medium: "1.75rem",
        large: "2rem",
        largest: "2rem"
      },
      fontColor: { desktop: "#fff", mobile: "#000" },
      fontWeight: "bold",
      paddingMobile: "16px"
    },
    borders: "2px solid #000",
    description: {
      fontFamily: "Gibson-Regular",
      fontSizes: { medium: "1rem" },
      fontColor: { desktop: "#fff", mobile: "#404041" },
      fontWeight: "normal",
      textTransform: ""
    },
    button: {
      backgroundColor: { desktop: "#fff", mobile: "#9E1D21" },
      font: {
        fontFamily: "Gibson-SemiBold",
        fontSizes: {
          smallest: "1.25rem",
          small: "1.25rem",
          medium: "1.25rem",
          large: "1.5rem",
          largest: "1.5rem"
        },
        fontColor: { desktop: "#000", mobile: "#fff" },
        fontWeight: "bold"
      },
      borderColor: { desktop: "transparent", mobile: "transparent" },
      hoverColor: { desktop: "#EDEDED", mobile: "#731518" }
    },
    padding: ""
  }
};

// src/bbi/carrabbas/carrabbasComponentsStyle/carrabbasHeader.ts
var carrabbasHeaderStyle = {
  image: {
    width: "130px",
    height: "auto"
  },
  title: {
    fontSizes: {
      small: "1rem",
      medium: "1rem"
    }
  },
  subTitle: {
    fontSizes: {
      small: "14px",
      medium: "18px"
    }
  }
};

// src/bbi/carrabbas/carrabbasUITheme.ts
var CarrabbasUITheme = {
  accordion: carrabbasAccordion,
  ButtonCMS: carrabbasButtonCmsStyle,
  carouselDots: {
    iconPlayAndPause: {
      background: "transparent",
      color: "#9E1D21"
    },
    background: "#ffffff"
  },
  footer: {
    letterSpacing: "0px",
    navbar: {
      marginBottom: "10px",
      color: "#404041",
      secondary: {
        fontFamily: "Gibson-SemiBold",
        menuItem: {
          fontSizes: {
            smallest: "16px",
            small: "16px",
            medium: "16px",
            large: "16px",
            largest: "16px"
          }
        }
      },
      terciary: {
        fontFamily: "Gibson-Regular",
        menuItem: {
          fontSizes: {
            smallest: "14px",
            small: "14px",
            medium: "14px",
            large: "14px",
            largest: "14px"
          }
        }
      }
    },
    socialMediaPanel: {
      fontFamily: "Gibson-Regular,sans-serif",
      fontSizes: {
        medium: "14px",
        large: "14px",
        largest: "14px"
      }
    }
  },
  navBar: {
    primary: {
      fontFamily: "Gibson-SemiBold",
      fontWeight: "bold",
      fontColor: "",
      fontSizes: {
        default: "1.5rem"
      },
      color: "#232222"
    }
  },
  topMessage: {
    text: {
      fontFamily: "Gibson-SemiBold",
      fontSizes: {
        default: "14px",
        medium: "18px"
      }
    }
  },
  header: carrabbasHeaderStyle,
  pod: carrabbasPodStyle,
  forms: {
    button: {
      fontColor: "#404041",
      backgroundColor: "#FFFFFF",
      border: "2px solid",
      fontWeight: "600",
      fontFamily: "Gibson-SemiBold",
      fontSizes: {
        small: "1.25rem",
        medium: "1.5rem",
        large: "1.5rem"
      },
      hoverColor: "#EDEDED"
    },
    texts: {
      title: {
        fontColor: "#232222",
        fontSizes: {
          small: "1.75rem",
          medium: "2rem",
          large: "2.25rem"
        },
        fontFamily: "Gibson-SemiBold",
        fontWeight: "600"
      },
      description: {
        fontColor: "#232222",
        fontSizes: { medium: "1rem" },
        fontFamily: "Gibson-Regular",
        fontWeight: "400"
      },
      label: {
        fontColor: "#404041",
        fontFamily: "Gibson-Regular",
        fontWeight: "600"
      }
    },
    backgroundColor: "#F5F3EB",
    borders: "#404041"
  },
  hero: carrabbasHero,
  animatedCard: {
    title: {
      fontColor: "#931C20",
      fontFamily: "Gibson-SemiBold",
      fontWeight: "600",
      fontSizes: {
        medium: "2rem",
        large: "2.25rem"
      }
    },
    text: {
      fontColor: "#404041",
      fontFamily: "Gibson-Regular",
      fontWeight: "400",
      fontSizes: {
        medium: "1rem"
      }
    }
  },
  animatedCardSecondary: {
    title: {
      fontColor: "#404041",
      fontFamily: "Gibson-Regular",
      fontWeight: "400",
      fontSizes: {
        medium: "2rem"
      }
    },
    text: {
      fontColor: "#666666",
      fontFamily: "Gibson-Regular",
      fontWeight: "400",
      fontSizes: {
        medium: "1rem"
      }
    },
    button: {
      fontColor: "#ffffff",
      fontFamily: "Gibson-SemiBold",
      fontWeight: "600",
      fontSizes: {
        medium: "0.875rem",
        large: "1.3rem"
      },
      backgroundColor: "#404041"
    }
  },
  catalogItem: {
    title: {
      font: {
        fontFamily: "Gibson-SemiBold",
        fontColor: "#931c20",
        fontWeight: "600"
      },
      fontSize: {
        fontSizes: {
          medium: "2.25rem",
          small: "2rem",
          smallest: "1.75rem"
        }
      }
    },
    subtitle: {
      font: {
        fontFamily: "Gibson-SemiBold",
        fontColor: "#404041",
        fontWeight: "600"
      },
      fontSize: {
        fontSizes: {
          medium: "1.25rem",
          small: "1rem",
          smallest: "0.75rem"
        }
      }
    },
    text: {
      font: {
        fontFamily: "Gibson-Regular",
        fontColor: "#404041",
        fontWeight: "400"
      },
      fontSize: {
        fontSizes: {
          medium: "1rem",
          small: "1rem",
          smallest: "1rem"
        }
      }
    },
    note: {
      font: {
        fontFamily: "Gibson-Regular",
        fontColor: "#931c20",
        fontWeight: "400"
      },
      fontSize: {
        fontSizes: {
          medium: "1rem",
          small: "1rem",
          smallest: "1rem"
        }
      }
    }
  },
  catalogItemSecondary: carrabbasCatalogItemSecondaryStyle,
  textButtonBanner: {
    title: {
      fontColor: "#ffffff",
      fontFamily: "Gibson-SemiBold",
      fontSizes: {
        small: "1rem",
        medium: "1.25rem",
        large: "1.5rem"
      },
      fontWeight: "600"
    },
    button: {
      fontColor: "#404041",
      fontFamily: "Gibson-SemiBold",
      fontSizes: {
        small: "1rem",
        medium: "1.25rem",
        large: "1.5rem"
      },
      fontWeight: "600",
      backgroundColor: "#ffffff"
    }
  },
  inputCms: carrabbasInputCmsStyle,
  rewardsModal: carrabbasRewardsModal,
  cardSecondary: carrabbasCardSecondaryStyles,
  grid: {
    maxWidth: "900px",
    margin: "auto"
  },
  jumbotron: carrabbasJumbotronStyles,
  catalog: carrabbasCatalogStyle,
  line: carrabbasLine,
  newsletterForm: carrabbasNewsletterForm,
  tabNavigationItem: carrabbasTabNavigationItem,
  questionsAndAnswersItem: carrabbasQuestionsAndAnswersItem,
  questionsAndAnswers: carrabbasQuestionsAndAnswers,
  lateralBar: carrabbasLateralBar,
  legalPages: carrabbasLegalPagesStyle,
  videoTextButton: carrabbasVideoTextButton
};

// src/bbi/carrabbas/carrabbasTheme.ts
var CarrabbasTheme = __spreadProps(__spreadValues({}, CarrabbasSharedTheme), {
  components: __spreadValues({}, CarrabbasUITheme),
  cmsComponents: __spreadValues({}, CarrabbasCmsTheme)
});

// src/types/theme.d.ts
var import_styled_components3 = require("styled-components");
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  CarrabbasCmsTheme,
  CarrabbasSharedTheme,
  CarrabbasTheme,
  CarrabbasUITheme,
  OutbackCmsTheme,
  OutbackSharedTheme,
  OutbackTheme,
  OutbackUITheme
});
